import { Button, Heading, Image, Layout, Text } from '../../../components/core';
import { HeadingLevel } from '../../../components/core/Heading';
import { IconChevronRight } from '../../../components/icons/IconChevronRight';
import { useExternalNavigate } from '../../../routes';
import { getStylesheet } from '../../../styles';

type IntegrationCardProps = {
  descriptionText: string;
  headingLevel: HeadingLevel;
  headingText: string;
  linkText: string;
  linkUrl: string;
  logoHeight: number;
  logoUrl: string;
  serviceName: string;
};

export const IntegrationCard = ({
  descriptionText,
  headingLevel,
  headingText,
  linkText,
  linkUrl,
  logoHeight,
  logoUrl,
  serviceName,
}: IntegrationCardProps): JSX.Element => {
  const externalNavigate = useExternalNavigate();

  const onIntegrationCardClick = (): void => {
    externalNavigate(linkUrl);
  };

  return (
    <Layout.Shift {...styles.integrationCardBox}>
      <Image
        alt={`${serviceName} logo`}
        aria-hidden
        height={logoHeight}
        minWidth={100}
        width={100}
        resizeMethod="auto"
        resizeMode="contain"
        source={{
          uri: logoUrl,
        }}
      />

      <Layout.VStack {...styles.integrationCardContent} space={1}>
        <Layout.VStack space={4}>
          <Heading.h4 aria-label={`${serviceName}: ${headingText}`} level={headingLevel}>
            {headingText}
          </Heading.h4>

          <Text.paraSmall>{descriptionText}</Text.paraSmall>
        </Layout.VStack>

        <Button.tertiaryMedium
          {...styles.integrationCardLink}
          aria-label={`${linkText} (opens in new tab)`}
          isLink
          rightIcon={<IconChevronRight aria-hidden size={6} />}
          testID={`button-home-go-to-${serviceName}`}
          onPress={onIntegrationCardClick}
        >
          {linkText}
        </Button.tertiaryMedium>
      </Layout.VStack>
    </Layout.Shift>
  );
};

const styles = getStylesheet({
  integrationCardBox: {
    alignContent: 'flex-start',
    backgroundColor: 'white',
    borderColor: 'secondary.200',
    borderRadius: 8,
    borderWidth: 1,
    gap: 6,
    justifyContent: 'space-between',
    overflow: 'hidden',
    paddingBottom: 3,
    paddingTop: 6,
    paddingX: 6,
  },

  integrationCardLink: {
    paddingLeft: 0,
    alignSelf: 'flex-start',
  },

  integrationCardContent: {
    flex: 1,
  },
});
